import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Timeline, {
  DateHeader,
  SidebarHeader,
  TimelineHeaders,
} from "react-calendar-timeline/lib";
import "./Schedule.css";
import { myDesignService, zoneScheduleService } from "../../../services";
import Grid from "@mui/material/Grid";
// import { addWeeks, endOfYear, startOfYear } from 'date-fns';
// import { formatToTimeZone } from 'date-fns-timezone';
// import DateFnsUtils from '@date-io/date-fns';
// import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';

import { DateTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import i18next from "i18next";

// import { formatWithLocale as format, locales } from '../../../helpers/format';
import { AddAlarm, Event, LinkOutlined } from "@mui/icons-material";
import {
  Button,
  Card,
  CircularProgress,
  Container,
  Link,
  Tooltip,
} from "@mui/material";
import ResponsiveDialogManager from "../../../components/dialog/ResponsiveDialogManager";
import ScheduleForm from "./ScheduleForm";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import { useViewport } from "../../../helpers";
import { useParams } from "react-router-dom";

const PREFIX = "Schedule";

const classes = {
  tooltip: `${PREFIX}-tooltip`,
};

const Root = styled("div")(({ theme }) => ({
  [`& .${classes.tooltip}`]: {
    backgroundColor: "#484848",
    color: "rgba(255, 255, 255, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}));

export default function Schedule(props) {
  const { width } = useViewport();
  const { t, i18n } = useTranslation();
  window.__localeId__ = i18n.language;
  const { id, targetLabel, index } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const [groups, setGroups] = useState([]);
  const [data, setData] = useState([]);
  const [reload, setReload] = useState(false);
  const [reloadData, setReloadData] = useState(false);
  const [schedule, setSchedule] = useState(false);
  const [itemSelected, setItemSelected] = useState(null);
  const [zone, setZone] = useState(null);
  const [campaigns, setCampaigns] = useState(null);

  useEffect(() => {
    if (props.isAdmin) {
      myDesignService
        .fetchAvailableCampaigns(props.frameId, () =>
          enqueueSnackbar(t("toasts.errorFetchAvailableCampaigns"), {
            variant: "error",
          })
        )
        .then((res) => setCampaigns(res));
    }
  }, []);

  const handleDateChange = (key, date) => {
    if (!date) {
      setFilters({
        from: filters.from,
        to: filters.to,
        [key]: dayjs(date).format("YYYY-MM-DDTHH:mm"),
      });
    }
    if (date) {
      setReload(true);
      setFilters({
        from: filters.from,
        to: filters.to,
        [key]: dayjs(date).format("YYYY-MM-DDTHH:mm"),
      });
      setTimeout(() => {
        if (filters.from && filters.to) setReload(false);
      }, 500);
    }
  };
  const [filters, setFilters] = useState({
    // from: startOfYear(dayjs()),
    from: dayjs().startOf("year"),
    // to: endOfYear(dayjs()),
    to: dayjs().endOf("year"),
  });

  // function formatDate(date, timezone) {
  //   if (timezone) {
  //     return formatToTimeZone(date, 'yyyy-MM-dd HH:mm', timezone).toISOString()
  //   }
  //   return dayjs(date).format("YYYY-MM-DDTHH:mm");
  // }

  function loadData(zeZone) {
    const finalId = id || props.frameId;
    const finalTargetLabel = targetLabel || props.target;
    const finalIndex = index || props.index;
    zoneScheduleService
      .fetchAllSchedules(
        finalId,
        finalTargetLabel,
        finalIndex,
        dayjs(filters.from).format("YYYY-MM-DDTHH:mm"),
        dayjs(filters.to).format("YYYY-MM-DDTHH:mm")
      )
      .then((results) => {
        setGroups([
          {
            id: -1,
            title: `Zone "${
              props.currentZone
                ? props.currentZone.label
                : zone
                ? zone.label
                : zeZone.label
            }"`,
          },
          ...results.map((r) => ({
            id: r.id,
            title: r.title ? r.title : r.targetUrl,
          })),
        ]);
        setData([
          {
            id: -1,
            group: -1,
            zeTitle: `${zone ? zone.targetUrl : zeZone.targetUrl}`,
            // start_time: addWeeks(filters.from, -2500),
            start_time: dayjs(filters.from).add(-2500, "week"),
            // end_time: addWeeks(filters.to, 2500),
            end_time: dayjs(filters.to).add(2500, "week"),
          },
          ...results.map((r) => ({
            id: r.id,
            group: r.id,
            zeTitle: r.targetUrl,
            start_time: dayjs(r.beginDate),
            end_time: dayjs(r.endDate),
            ...r,
          })),
        ]);
      });
  }

  function itemRenderer({ item, itemContext, getItemProps }) {
    const itemProps = {
      ...getItemProps(item.itemProps),
      title: null,
    };
    return (
      <Root>
        <Tooltip
          title={
            item.id !== -1 ? (
              <React.Fragment>
                <div>
                  <em>{t("myDesign.zones.schedule.destination")} - </em>
                  <b>
                    <Link
                      href={item.targetUrl}
                      target="_blank"
                      color={"primary"}
                    >
                      {item.targetUrl}
                    </Link>
                  </b>
                </div>
                <em>{t("myDesign.zones.schedule.from")}</em>{" "}
                <b>{dayjs(item.start_time).format("YYYY-MM-DD")}</b>
                <em>{t("myDesign.zones.schedule.to")}</em>{" "}
                <b>{dayjs(item.end_time).format("YYYY-MM-DD")}</b>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <div>
                  <em>{t("myDesign.zones.schedule.destination")} - </em>
                  <b>
                    <Link
                      href={zone.targetUrl}
                      target="_blank"
                      color={"primary"}
                    >
                      {zone.targetUrl}
                    </Link>
                  </b>
                </div>
                <em>{t("myDesign.zones.schedule.definitiveRedirect")}</em>
              </React.Fragment>
            )
          }
          classes={{
            tooltip: classes.tooltip,
          }}
        >
          <div {...itemProps}>
            <div
              className="rct-item-content"
              style={{
                maxHeight: `${itemContext.dimensions.height}`,
                backgroundColor: "transparent !important",
              }}
            >
              {item.zeTitle}
            </div>
            <Link
              href={item.targetUrl}
              target="_blank"
              color="primary"
              className="scheduleLink"
            >
              <LinkOutlined />
            </Link>
          </div>
        </Tooltip>
      </Root>
    );
  }

  useEffect(() => {
    const finalId = id || props.frameId;
    const finalTargetLabel = targetLabel || props.target;
    const finalIndex = index || props.index;

    if (props.timezone || props.index || props.index === 0) {
      if (!zone) {
        const zeZone = props.zones.find((z) => {
          // eslint-disable-next-line eqeqeq
          return (
            z.frameId == finalId &&
            z.target === finalTargetLabel &&
            z.index == finalIndex
          );
        });
        setZone(zeZone);
        loadData(zeZone);
      } else if (props.currentZone) {
        setZone(props.currentZone);
        loadData(props.currentZone);
      } else {
        loadData();
      }
    }
  }, [props.timezone, props.index]);

  useEffect(() => {
    if (reloadData) {
      loadData();
    }
  }, [reloadData]);

  function onItemSelect(itemId, element) {
    if (
      element.target.nodeName === "svg" ||
      element.target.nodeName === "path"
    ) {
      let url = data.find((elt) => elt.id === itemId).targetUrl;
      if (!url.startsWith("http")) url = "http://" + url;
      window.open(url, "_blank");
    } else {
      if (itemId > 0) {
        setItemSelected(data.find((elt) => elt.id === itemId));
        toggleSchedule();
      }
    }
  }

  function newSchedule() {
    setItemSelected(null);
    toggleSchedule();
  }

  function toggleSchedule() {
    setSchedule((prev) => !prev);
  }

  function handleClose() {
    setSchedule(false);
  }

  function saveSchedule(data) {
    let zePromise;
    if (!data.id) {
      let finalId = props.frameId ? props.frameId : id;
      let finalTargetLabel = props.target ? props.target : targetLabel;
      let finalIndex = props.index ? props.index : id;
      if (data.file) {
        zePromise = zoneScheduleService.addScheduleWithVideo(
          finalId,
          finalTargetLabel,
          finalIndex,
          {
            beginDate: data.beginDate,
            endDate: data.endDate,
            targetUrl: `${data.http}${data.targetUrl}`,
            planifTitle: data.title,
            planifDescription: data.description,
            title: data.videoTitle,
            description: data.videoDescription,
          },
          data.file
        );
      } else if (!data.file && data.campaignId) {
        data.frameZoneId = props.currentZone.id;
        zePromise = zoneScheduleService.addCampaignSchedule(finalId, data);
      } else {
        zePromise = zoneScheduleService.addSchedule(
          finalId,
          finalTargetLabel,
          finalIndex,
          {
            beginDate: data.beginDate,
            endDate: data.endDate,
            targetUrl: `${data.http}${data.targetUrl}`,
            title: data.title,
            description: data.description,
          }
        );
      }
    } else {
      if (data.file) {
        zePromise = zoneScheduleService.updateScheduleWithVideo(
          data.frameId,
          data.id,
          {
            beginDate: data.beginDate,
            endDate: data.endDate,
            targetUrl: `${data.http}${data.targetUrl}`,
            title: data.title,
            description: data.description,
            videoTitle: data.videoTitle,
            videoDescription: data.videoDescription,
          },
          data.file,
          zone.id
        );
      } else {
        zePromise = zoneScheduleService.updateSchedule(data.frameId, data.id, {
          beginDate: data.beginDate,
          endDate: data.endDate,
          targetUrl: `${data.http}${data.targetUrl}`,
          title: data.title,
          description: data.description,
        });
      }
    }
    zePromise
      .then(() => {
        setReloadData(true);
        handleClose();
        setReloadData(false);
        enqueueSnackbar(
          data.id
            ? t("toasts.planifUpdateSuccess")
            : t("toasts.planifCreateSuccess")
        );
      })
      .catch((err) => {
        if (err === 403)
          enqueueSnackbar(t("toasts.unauthorizedError"), {
            variant: "error",
          });
        else
          enqueueSnackbar(
            data.id
              ? t("toasts.planifUpdateError")
              : t("toasts.planifCreateError")
          );
      });
  }

  function deleteSchedule(scheduleId) {
    zoneScheduleService
      .deleteSchedule(itemSelected.frameId, scheduleId)
      .then(() => {
        setReloadData(true);
        handleClose();
        setReloadData(false);
        enqueueSnackbar(t("toasts.planifDeletedSuccess"));
      })
      .catch((err) => {
        if (err === 403)
          enqueueSnackbar(t("toasts.unauthorizedError"), {
            variant: "error",
          });
        else enqueueSnackbar(t("toasts.planifDeletedError"));
      });
  }

  function formatLabelHeader(moment, unit) {
    const date = moment[0].toDate();
    switch (unit) {
      case "year":
        return dayjs(date).format("YYYY");
      case "month":
        if (width > 768) return dayjs(date).format("MMM");
        else return dayjs(date).format("M");
      case "day":
        return dayjs(date).format("d");
      case "hour":
        return dayjs(date).format("HH");
      default:
        return dayjs(date).format("YYYY");
    }
  }

  return (
    <Root>
      <div className="filters">
        <div className="filtersTitle">
          <h1 className="titlePlanif">
            <Event className="iconTitlePlanif" />
            {t("myDesign.zones.schedule.title")}
          </h1>
        </div>
        <Card
          className="card-filters"
          sx={{ backgroundColor: "#424242", padding: "0.5rem" }}
        >
          {/* <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locales[i18n.languages[1]]}> */}
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale={i18next.language.substring(0, 2)}
          >
            <Grid container justifyContent="space-around">
              <DateTimePicker
                margin="normal"
                id="from-date-picker-dialog"
                label={t("myDesign.zones.schedule.from")}
                onChange={(e) => handleDateChange("from", e)}
                value={dayjs(filters.from)}
              />
              {/* <KeyboardDateTimePicker
                margin="normal"
                id="from-date-picker-dialog"
                label={t('myDesign.zones.schedule.from')}
                format="Pp"
                value={filters.from}
                onChange={(e) => handleDateChange('from', e)}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
              /> */}
              <DateTimePicker
                id="to-date-picker-dialog"
                label={t("myDesign.zones.schedule.to")}
                onChange={(e) => handleDateChange("to", e)}
                value={dayjs(filters.to)}
                minDate={dayjs(filters.from)}
              />
              {/* <KeyboardDateTimePicker
                margin="normal"
                id="to-date-picker-dialog"
                label={t('myDesign.zones.schedule.to')}
                format="Pp"
                value={filters.to}
                onChange={(e) => handleDateChange('to', e)}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
                minDate={filters.from}
              /> */}
            </Grid>
            {/* </MuiPickersUtilsProvider> */}
          </LocalizationProvider>
        </Card>
        {data && data.length > 0 ? (
          <div className="marginL1">
            {!reload && filters.from && filters.to && (
              <Timeline
                groups={groups}
                items={data}
                defaultTimeStart={dayjs(filters.from)}
                defaultTimeEnd={dayjs(filters.to)}
                onItemSelect={onItemSelect}
                canResize={false}
                canMove={false}
                selected={[]}
                itemRenderer={itemRenderer}
                sidebarWidth={width > 768 ? 150 : 80}
              >
                <TimelineHeaders>
                  <SidebarHeader>
                    {({ getRootProps }) => {
                      return (
                        <div {...getRootProps()} className="addSchedule">
                          <Button
                            onClick={newSchedule}
                            size="small"
                            variant="outlined"
                            className="buttonAddSchedule"
                            color={"primary"}
                          >
                            {width > 768 && t("myDesign.zones.schedule.add")}
                            <AddAlarm className="marginLeft5" />
                          </Button>
                        </div>
                      );
                    }}
                  </SidebarHeader>
                  <DateHeader
                    unit="primaryHeader"
                    labelFormat={formatLabelHeader}
                  />
                  <DateHeader labelFormat={formatLabelHeader} />
                </TimelineHeaders>
              </Timeline>
            )}
          </div>
        ) : (
          <Container className="centerFlex">
            <CircularProgress color={"primary"} />
            <div>{t("myDesign.zones.schedule.loadingData")}</div>
          </Container>
        )}
      </div>
      <ResponsiveDialogManager
        renderer={
          <ScheduleForm
            validate={saveSchedule}
            cancel={handleClose}
            form={itemSelected}
            deleteSchedule={deleteSchedule}
            campaigns={campaigns}
            isAdmin={props.isAdmin}
          />
        }
        title={
          itemSelected
            ? t("myDesign.zones.schedule.modifyPlanif")
            : t("myDesign.zones.schedule.newPlanif")
        }
        open={schedule}
        onClose={handleClose}
      />
    </Root>
  );
}
